import { render } from "./EditReflectionSubKomunitasView.vue?vue&type=template&id=254c7c5e"
import script from "./EditReflectionSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./EditReflectionSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__